import { TAnalyticsTrackEvent, TAnalyticsTrackPage } from '../constant';

/* GTM Track by Event */

const trackByEvent: TAnalyticsTrackEvent = (event,data) => {
  try {
      if(typeof dataLayer === 'undefined') {
        console.warn('GTM datalayer is no available');   
        return;
      }
      if(data) {
        dataLayer.push({event:event,...data})
      }
  } catch (error) {
    console.error(' GTM Service trackByEvent',error);
  }
}

/* GTM Track by Page */
const trackByPage: TAnalyticsTrackPage = (page,data) => {

  try {
    
    if( typeof dataLayer === 'undefined') {
      console.warn('GTM is not available');
      return;
    }
    if(data) {
      dataLayer.push({event: 'Pageview',...data});
    }


  } catch (error) {
    console.error(' GTM Service trackByPage',error);
  }

}

const initialiseController = () => {
  try {
    if (typeof dataLayer === 'undefined') {
      console.warn('tms controller is not available');

      return;
    }

    dataLayer.push({});
  } catch (error) {
    console.error('Tealium Service initialiseController', error);
  }
};

export { trackByPage, trackByEvent, initialiseController };
